import React, { useState, useEffect } from 'react';
import { formatters } from '../services/api';
import './Footer.css';

const Footer: React.FC = () => {
  const [lastUpdated, setLastUpdated] = useState<string>('');

  useEffect(() => {
    // Update the last updated timestamp
    const updateTime = () => {
      setLastUpdated(new Date().toLocaleTimeString());
    };

    updateTime();
    const interval = setInterval(updateTime, 60000); // Update every minute

    return () => clearInterval(interval);
  }, []);

  const handleNavClick = (page: string) => {
    window.location.hash = page === 'home' ? '' : `#${page}`;
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section footer-brand">
            <img src="/logo.png" alt="Cryptoware" className="footer-logo" />
            <h4>Cryptoware</h4>
            <p>High performace Kaspa mining pool</p>
          </div>
          
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#" onClick={() => handleNavClick('home')}>Home</a></li>
              <li><a href="#dashboard" onClick={() => handleNavClick('dashboard')}>Dashboard</a></li>
              <li><a href="#help" onClick={() => handleNavClick('help')}>Help</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Stats</h4>
            <p>Last update: <span className="last-updated">{lastUpdated || '--'}</span></p>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2025 Cryptoware | All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
